import { IScheduledEmail } from '@/types/email.types';
import { Put } from '../helpers';

export async function EditScheduledEmail(email: IScheduledEmail): Promise<IScheduledEmail> {
  const params = new URLSearchParams();
  if (localStorage.getItem('blp-force-fail') === 'true') {
    params.append('fail', '1');
  }
  return Put({
    path: `/v3/admin/scheduled-emails?${params.toString()}`,
    body: { editScheduledEmail: email },
  });
}
